import { render } from "./AuthLayout.vue?vue&type=template&id=c2b96a5c&scoped=true&ts=true"
import script from "./AuthLayout.vue?vue&type=script&lang=ts"
export * from "./AuthLayout.vue?vue&type=script&lang=ts"

import "./AuthLayout.vue?vue&type=style&index=0&id=c2b96a5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2b96a5c"]])

export default __exports__